
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cpap/privacy-policy",
      function () {
        return require("private-next-pages/cpap/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cpap/privacy-policy"])
      });
    }
  